"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ModalContent;
var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _react = _interopRequireWildcard(require("react"));
var _uniqid = _interopRequireDefault(require("uniqid"));
var _bemit = _interopRequireDefault(require("Functions/bemit"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ModalContent(props) {
  const open_ref = (0, _react.useRef)();
  const ref_history = (0, _react.useRef)();
  const ref = (0, _react.useRef)();
  const [id, setId] = (0, _react.useState)((0, _uniqid.default)());
  const config_scroll = props['scroll-area'];
  const openModal = (0, _react.useCallback)(function () {
    const modal = document.getElementById(id);
    if (!modal) return;
    temperDocumentScroll('remove', config_scroll, id);
    modal.focus();
    modal.classList.remove('c-modal-cover--fade');
    modal.lastChild.classList.remove('c-modal--fade');
  }, [config_scroll, id]);
  const closeModal = (0, _react.useCallback)(function (e) {
    const modal = document.getElementById(id);
    if (!modal) return;
    if (props['prevent-close']) return;
    const other_modal = document.querySelector('[id="' + id + '"] ~ .js-app-modal-cover');
    if (other_modal) return;
    modal.classList.add('c-modal-cover--fade');
    modal.lastChild.classList.add('c-modal--fade');
    if (props.open === true) props.onClose(e);
  }, [id, props]);
  (0, _react.useEffect)(function () {
    if (props.open === false) {
      closeModal();
    } else {
      openModal();
    }
  }, [props.open, closeModal, openModal]);
  (0, _react.useEffect)(function () {
    const changed = open_ref.current !== props.open;
    open_ref.current = props.open;
    if (props.open !== true) {
      ref.current?.close?.();
    } else {
      ref_history.current = (0, _cloneDeep2.default)(window.history?.state);
      window.addEventListener('popstate', onHistoryPop);
      ref.current?.showModal?.();
    }
    if (changed) {
      if (props.open) {
        history.pushState('modal-' + id, '');
      } else if (window.history?.state === 'modal-' + id) {
        history.back(); // supprime l'historique qu'on a ajouté
      }
    }
    return () => window.removeEventListener('popstate', onHistoryPop);
    function onHistoryPop(e) {
      if (props.open !== true) return;

      // on est revenu à l'état précédant la modale ce qui veut dire que le
      // state de la modale a été retiré
      if ((0, _isEqual2.default)(window.history?.state, ref_history.current)) {
        ref.current?.close?.();
      }
    }
  }, [props.open, ref, id]);
  const stopPropagation = (0, _react.useCallback)(e => e.stopPropagation(), []);
  const modal_controls = props.footer ? props.footer : props['hide-footer'] ? undefined : /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    "aria-label": "Fermer",
    className: props['close-classes'] || (0, _bemit.default)('c-flat-btn'),
    onClick: closeModal
  }, props['close-label'] || 'Fermer');
  const no_bg_close = [true, 'true'].includes(props['prevent-bg-close']);
  return /*#__PURE__*/_react.default.createElement("dialog", {
    id: id,
    ref: ref,
    className: 'js-app-modal-cover ' + (0, _bemit.default)('c-modal-cover', props.bemit),
    onMouseDown: no_bg_close ? undefined : closeModal,
    onTransitionEnd: handleAnimationEnd,
    onAnimationEnd: handleAnimationEnd,
    "aria-modal": "true",
    tabIndex: "-1",
    "aria-labelledby": props['aria-label'] || props.title,
    onClose: closeModal
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _bemit.default)('c-modal', props.bemit),
    onMouseDown: stopPropagation,
    onTransitionEnd: stopPropagation,
    onAnimationEnd: stopPropagation,
    role: "presentation"
  }, props['hide-header'] ? undefined : /*#__PURE__*/_react.default.createElement("div", {
    className: "c-modal__header",
    id: "modal-title"
  }, props.title ? /*#__PURE__*/_react.default.createElement("div", {
    className: "c-modal__title"
  }, props.title) : undefined), /*#__PURE__*/_react.default.createElement("div", {
    className: "c-modal__body"
  }, props.children), modal_controls ? /*#__PURE__*/_react.default.createElement("div", {
    className: "c-modal__controls-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "c-modal__controls"
  }, modal_controls)) : undefined, /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "c-modal__close",
    onClick: closeModal,
    "aria-labelledby": 'modal-close' + id
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "u-hide-visually",
    id: 'modal-close' + id
  }, "Fermer"), /*#__PURE__*/_react.default.createElement("svg", {
    className: "c-modal__close-icon",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M 10,10 L 30,30 M 30,10 L 10,30"
  })))));
  function handleAnimationEnd(e) {
    props.onAnimationEnd(e);
    if (props.open !== true) {
      temperDocumentScroll('restore', config_scroll, id);
    }
  }
}
function temperDocumentScroll(what, config_scroll, id) {
  const native_scroller = document.scrollingElement || document.body;
  const scroll_width = window.innerWidth - native_scroller.clientWidth;
  let scroll_area = config_scroll ? document.querySelector(config_scroll) : native_scroller;
  if (!scroll_area) {
    console.error('invalid modal scroll-area', config_scroll);
  }
  if (what === 'remove') {
    document.querySelector('html').classList.add('u-lock-scroll-' + id);
    if (scroll_width > 0) {
      scroll_area.style.paddingRight = scroll_width + 'px';
    }
  } else {
    document.querySelector('html').classList.remove('u-lock-scroll-' + id);
    const still_locked = document.querySelector('html').className.includes('u-lock-scroll');
    if (!still_locked) {
      scroll_area.style.paddingRight = '';
    }
  }
}
